// ** Logo
import logo from '@src/assets/images/logo/logo.svg'
import styles from './SpinnerComponent.module.css'

const SpinnerComponent = () => {
  return (
    <div className={styles['spinner-wrapper']}>
      <img className={`${styles['center-image']}`} src={logo} alt='logo' />
      {/* <div className={styles.loader}></div> */}
    </div>
  )
}

export default SpinnerComponent
